import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { EventHubsListPresentation } from './event-hubs-list.presentation';
import { EventHubsListVM } from './event-hubs-list.viewmodel';


export const EventHubsList = withViewModel(EventHubsListPresentation, () => {
    const vm = new EventHubsListVM();

    vm.initialize();
    return vm;
});
